import React from 'react';

const HomePageLoading = () => (
  <div className="vs-home-root flex min-h-screen items-center justify-center">
    <div className="animate-spin h-12 w-12 border-b-2" />
  </div>
);

export default React.memo(HomePageLoading);
